import React, { useContext } from "react"
import { Link } from "gatsby"
import ReactMarkdown from "react-markdown"
import ReactAwesomePlayer from 'react-awesome-player'
import { checkPropTypes } from "prop-types"

function getMediaContainer(mainMediaPublicURL, placeholderMediaPublicURL, caption, title) {
  // var url = mainMedia.localFile.publicURL;
  var myid = Math.round(Math.random()*10000000);
  if (mainMediaPublicURL.endsWith("mp4")) {
    return <>
      <a href={mainMediaPublicURL} data-width={title === "audio" ? "1632" : ""} data-height={title === "audio" ? "340" : ""} className={"swiper-zoom-container type-video" + (title === "audio" ? " audio-video" : "")} data-fancybox={Math.random()} data-caption={caption == undefined ? "" : caption}>
        <div className={title === "audio" ? "play-btn-audio" : "play-btn"}></div>
        <img src={placeholderMediaPublicURL} />
      </a>
    </>
  } else {
    return <a className="type-image" href={mainMediaPublicURL} data-options='{"buttons": ["close"], "arrows": false}' data-type="image" data-fancybox={Math.random()} data-caption={caption == undefined ? "" : caption}>
      <img src={mainMediaPublicURL} />
    </a>;
  }
}

const renderImage = (props) => {
  // console.log(props);
  var mainMediaPublicURL = props.src;
  var placeholderMediaPublicURL = "";
  // markdown contains link to video with preview image src at the start
  if (mainMediaPublicURL.indexOf(",") > -1) {
    var splitUrls = mainMediaPublicURL.split(",");
    placeholderMediaPublicURL = splitUrls[0];
    mainMediaPublicURL = splitUrls[1];
  }
  if (placeholderMediaPublicURL.indexOf("/uploads/") > -1) {
    placeholderMediaPublicURL = "/uploads/" + placeholderMediaPublicURL.split("/uploads/")[1];
  }
  if (mainMediaPublicURL.indexOf("/uploads/") > -1) {
    mainMediaPublicURL = "/uploads/" + mainMediaPublicURL.split("/uploads/")[1];
  }
  var caption = props.alt;
  if (caption.endsWith(".jpg") || caption.endsWith(".png") || caption.endsWith(".gif") || caption.endsWith(".mp4") || caption.endsWith(".mov")) {
    caption = null;
  }
  var title = props.title;
  return getMediaContainer(mainMediaPublicURL, placeholderMediaPublicURL, caption, title);
}

const dontRenderLink = (props) => {
  console.log(props);
  return "";
}


// const renderVideo = (props) => {
//   return (
//     <pre>{JSON.stringify(props, null, 4)}</pre>
//     // <a className="type-image" href={props.src} data-options='{"buttons": ["close"], "arrows": false}' data-type="image" data-fancybox={Math.random()}>
//     //   <img {...props} />
//     // </a>
//   );
// }

const Slide = ({ data, mode, counter, b }) => {
  const getTitle = (item) => {
    var title = "";
    if (item && item.Title) {
      // if (language == "maori" && item.TitleMaori) {
      //   title = item.TitleMaori;
      // } else {
        title = item.Title;
      // }
    }
    return title.replace(/DL[0-9]{1,2}[- ]?/, "");
  }

  const getBody = (item) => {
    var body = "";
    if (item && item.Body) {
      // if (language == "maori" && item.BodyMaori) {
      //   body = item.BodyMaori;
      // } else {
        body = item.Body;
      // }
    }
    return body.replace(/\\/g, "  ");
  }

  if (mode == "caption") {
    return <div className="caption_credit">
      <div className="caption"><ReactMarkdown children={data.MediaCaption} /></div>
      <div className="credit"><ReactMarkdown children={data.Credit} /></div>
    </div>;
  } else if (mode == "sidebar") {
    return <div className="infobox">
      {/* <pre>{JSON.stringify(data.Body, null, 4)}</pre> */}
      <h3 data-swiper-parallax="-600">{getTitle(data)}</h3>
      <div className="text" data-swiper-parallax="-200">
        <ReactMarkdown
          children={getBody(data)}
          renderers={{
            image: renderImage,
            link: dontRenderLink,
          }} />
      </div>
      {/* <div className="slide-counter">{counter}</div> */}
    </div>;
  } else if (mode == "slide") {
    return <div className="main-slide">
      <div className="media">
        {/* <pre>{JSON.stringify(data, null, 4)}</pre> */}

        {data.Media && data.Media.localFile && getMediaContainer(data.Media.localFile.publicURL, data.VideoPlaceholderImage && data.VideoPlaceholderImage.localFile.publicURL, "", data.PlayIconStyle)}

        {/* <>{data.Media.mim e}</> */}
      </div>
    </div>;
  }
}

export default Slide
